import { computed, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import Keycloak from 'keycloak-js';
import { EnvironmentConfig } from '../services/environment.service';

@Injectable({ providedIn: 'root' })
export class KeycloakService {
  private keycloak!: Keycloak;

  private _authenticated = signal<boolean>(false);
  readonly isAuthenticated = computed(() => this._authenticated());

  constructor(private router: Router) {
    this.keycloak = new Keycloak({
      url: 'https://id-next.authflow.cloud/',
      realm: 'cymonz_uat',
      clientId: 'jsonrpc',
    });
  }

  setConfig(config: EnvironmentConfig) {
    this.keycloak = new Keycloak({
      url: `https://${config.auth}/`,
      realm: config.realm,
      clientId: config.client_id,
    });
  }

  init(): Promise<boolean> {
    const redirectUri = window.location.origin + window.location.pathname;

    return this.keycloak
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256',
        redirectUri,
      })
      .then((authenticated) => {
        console.log('Keycloak authenticated:', authenticated);
        this._authenticated.set(authenticated);
        return authenticated;
      })
      .catch((err) => {
        console.error('Keycloak init failed', err);
        this._authenticated.set(false);
        return false;
      });
  }

  login(): Promise<void> {
    return this.keycloak.login({
      redirectUri: window.location.origin + window.location.pathname,
    });
  }

  logout(): void {
    this._authenticated.set(false);
    this.keycloak.logout();
  }

  get token(): string | undefined {
    return this.keycloak.token;
  }

  get username(): string {
    return this.keycloak.tokenParsed?.['preferred_username'] || '';
  }

  updateToken(minValidity = 60): Promise<boolean> {
    return this.keycloak.updateToken(minValidity);
  }

  get instance(): Keycloak {
    return this.keycloak;
  }
}
